import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Home from '@/components/Home'
import Teacher from '@/components/Teacher'
import Student from '@/components/Student'
import Parent from '@/components/Parent'
import AppDownload from '@/components/AppDownload'
import AppTeachDownload from '@/components/AppTeachDownload'
import AppStudentDownload from '@/components/AppStudentDownload'
import Licence from '@/components/Licence'
import privates from '@/components/privates'
import race from '@/components/race'
import SignIndex from '@/components/sign/Clazz'
import SignStudent from '@/components/sign/Student'
import Sign from '@/components/sign/Sign'
import LingYongChuKu from '@/components/sign/LingYongChuKu'

import UserKnow from '@/components/UserKnow'
import Version from '@/components/Version'
import Agreement from '@/components/Agreement'

// import signUpList from '@/components/joint-assess/signUpList'
import signUpList from '@/components/joint-assess/signUpListTwo'
import signUpListPhone from '@/components/joint-assess/signUpListPhone'


import English from '@/components/advHtml/english'
import Matics from '@/components/advHtml/matics'
import SureLogin from '@/components/advHtml/surelogin'
import ForgetPassword from '@/components/ForgetPassWord'
import InitPassWord from '@/components/InitPassWord'
// import Methodtreasurepage from '../../copyRightmethodtreasurepage.html'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      children:[
        {
          path:'',
          name: 'Home',
          component: Home
        }
      ]
    },
    {
      path: '/privacy',
      name: 'privates',
      component: privates
    },
    {
      path: '/race',
      name: 'race',
      component: race
    },
    {
      path: '/index',
      name: 'Index',
      component: Index,
      children: [
        {
          path: 'teacher',
          name: 'Teacher',
          component: Teacher
        },
        {
          path: 'student',
          name: 'Student',
          component: Student
        },
        {
          path: 'parent',
          name: 'Parent',
          component: Parent
        },
      ]
    },
    {
      path: '/signUpList',
      name: 'signUpList',
      component: signUpList
    },
    {
      path: '/signUpListPhone',
      name: 'signUpListPhone',
      component: signUpListPhone
    },
    {
      path: '/app',
      name: 'AppDownload',
      component: AppDownload
    },
    // {
    //   path: '/methodtreasurepage',
    //   name: 'methodtreasurepage',
    //   component: Methodtreasurepage
    // },
    {
      path: '/teacherdownload',
      name: 'AppTeachDownload',
      component: AppTeachDownload
    },
    {
      path: '/studentdownload',
      name: 'AppStudentDownload',
      component: AppStudentDownload
    },
    {
      path: '/licence',
      name: 'Licence',
      component: Licence
    },
    {
      path: '/signclazz',
      name: 'SignClazz',
      component: SignIndex,
    },
    {
      path: '/signstu',
      name: 'SignStudent',
      component: SignStudent,
    },
    {
      path: '/sign',
      name: 'Sign',
      component: Sign,
    },
    {
      path: '/lingyong',
      name: 'LingYong',
      component: LingYongChuKu,
    },
    {
      path: '/userknow',
      name: 'UserKnow',
      component: UserKnow,
    },
    {
      path: '/version',
      name: 'Version',
      component: Version,
    },
    {
      path: '/agreement',
      name: 'Agreement',
      component: Agreement,
    },
    {
      path: '/forgetpassword',
      name: 'ForgetPassword',
      component: ForgetPassword,
    },
    {
      path: '/initPassword',
      name: 'InitPassWord',
      component: InitPassWord,
    },
    // 猜题活动页
    {
      path: '/english',
      name: 'english',
      component: English
    }, {
      path: '/matics',
      name: 'matics',
      component: Matics
    },
    {
      path: '/surelogin',
      name: 'surelogin',
      component: SureLogin
    },
    {
      path: '/bigdatalogin',
      name: 'BigDataLogin',
      component: () => import('../components/BigDataLogin')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js